

import { getProductVersions, getProductVersionsPromise } from "../../api";

export async function loader() {
    const { data } = await getProductVersions();
    return data?.data || [];
}

export function deferredLoader() {

    const fetchPromise = getProductVersionsPromise();

    return {
        productVersions: fetchPromise,
    };
}